import type {ValueEditorValidations} from './types';
import {requiredValidator} from '../internal/shared/validators';
import type {Validator} from 'svelte-forms';
import {exists, isDefined} from '../../utils/custom-utils';
import type {ValueEditorTypeOrAlias} from '../types';
import type {EditorsLocalizationFunction, ValueEditorLocalizations} from 'shared/value-editors/localizations/types';
import type {ValueEditorLocalizationManager} from 'shared/value-editors/localizations/value-editor-localization.manager';
import {setContext} from 'svelte';
import {EDITORS_LOCALIZE, ERRORS_LOCALIZE} from 'shared/value-editors/context-keys';
import type {
    ValueEditorErrorMessagesLocalizations
} from 'shared/value-editors/internal/errors/error-messages-localization.service';

export function validatorFactory(validations: ValueEditorValidations): Validator[] {
    const validators: Validator[] = [];

    if (isDefined(validations.required) && validations.required) {
        validators.push(requiredValidator())
    }

    return validators;
}

export function isMetaEditor(type: ValueEditorTypeOrAlias): boolean {
    return type === 'object' || type === 'list';
}

export function setEditorsLocalizationContext<LOC extends ValueEditorLocalizations>(localizations: LOC | null, localizationManager: ValueEditorLocalizationManager<LOC> | undefined) {
    setLocalizationContext(localizations, localizationManager, EDITORS_LOCALIZE);
}

export function setErrorsLocalizationContext(localizations: Partial<ValueEditorErrorMessagesLocalizations> | null, localizationManager: ValueEditorLocalizationManager<ValueEditorErrorMessagesLocalizations>) {
    setLocalizationContext(localizations, localizationManager, ERRORS_LOCALIZE);
}

function setLocalizationContext<LOC extends ValueEditorLocalizations>(localizations: LOC | null, localizationManager: ValueEditorLocalizationManager<LOC> | undefined, contextKey: string) {
    const localize: EditorsLocalizationFunction<LOC> = (code: (keyof LOC) & string) => {
        if (exists(localizations?.[code])) {
            return localizations[code];
        }

        if (exists(localizationManager)) {
            return localizationManager.getLocalization(code);
        } else {
            throw new Error('LocalizationManager is not set');
        }
    }

    setContext(contextKey, localize);
}